module.exports = {
    SCHEDULE_GET: 'SCHEDULE_GET',
    FAVORITE_CHANNELS_GET: 'FAVORITE_CHANNELS_GET',
};
